import { render, staticRenderFns } from "./TiposIncidenciaForm.vue?vue&type=template&id=0c88ce70&scoped=true"
import script from "./TiposIncidenciaForm.vue?vue&type=script&lang=js"
export * from "./TiposIncidenciaForm.vue?vue&type=script&lang=js"
import style0 from "./TiposIncidenciaForm.vue?vue&type=style&index=0&id=0c88ce70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88ce70",
  null
  
)

export default component.exports